import { NativeScrollSize, NativeScrollPoint } from 'react-native';

export const isCloseToBottom = (
  layoutMeasurement: NativeScrollSize,
  contentOffset: NativeScrollPoint,
  contentSize: NativeScrollSize,
  paddingToBottom: number,
) => {
  return layoutMeasurement.height + contentOffset.y >= contentSize.height - paddingToBottom;
};
